/**
 * Faits d'une fiche : des couples libellé · valeur (SIRET, n° de TVA, fluide,
 * prochain contrôle…), lus d'un coup d'œil. Une colonne au téléphone, deux à
 * partir de 600 px. Une valeur absente se dit (« Non renseigné ») au lieu de
 * laisser un trou ; un fait sans intérêt pour la fiche est simplement omis.
 */
import type { ReactNode } from 'react';

export interface Fact {
  label: string;
  /** `null` ou vide : « Non renseigné », en discret. */
  value: ReactNode;
  /** Précision sous la valeur (unité, date, origine). */
  hint?: ReactNode;
  /** Texte long (notes, consignes) : toute la largeur, retours à la ligne gardés. */
  wide?: boolean;
}

export function FactList(props: {
  label: string;
  facts: readonly (Fact | false | null | undefined)[];
  /** Texte d'une valeur absente. */
  missing?: string;
}): ReactNode {
  const facts = props.facts.filter((fact): fact is Fact => Boolean(fact));
  if (facts.length === 0) return null;
  return (
    <dl className="ui-facts" aria-label={props.label}>
      {facts.map((fact) => {
        const empty = fact.value === null || fact.value === undefined || fact.value === '';
        return (
          <div key={fact.label} className={fact.wide ? 'ui-facts__item ui-facts__item--wide' : 'ui-facts__item'}>
            <dt>{fact.label}</dt>
            <dd>
              {empty ? <span className="ui-facts__missing">{props.missing ?? 'Non renseigné'}</span> : fact.value}
              {fact.hint ? <small className="ui-facts__hint">{fact.hint}</small> : null}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
